import "highcharts/modules/drilldown";

import { ArrowRightOutlined } from "@ant-design/icons";
import { Button, Card, Table, Tag } from "antd";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import { ROUTES, SideBarMenus } from "routes/constants";
import { getRoute, PurchaseReportSalesView, SalesColumns, TolranceWebColumns, VehicleColumns } from "routes/utils";
import { HasPermission } from "utils/CheckPermissions";

import { PurachaseReportView } from "./purachaseViewItem";
import { SalesReportView } from "./salesReportView";
import { TatReportView } from "./tatreport-viewItem";
import { TolranceSalesViewUnderWeightItem } from "./tolaranceSalesUnderWeightView";
import { TolranceSalesViewItem } from "./tolaranceSalesView";
import { TolranceViewItem } from "./tolaranceview";
import { VehicleReportView } from "./vehicleReportView";

interface ReportViewItem_ {
  data:any;
  isLoading:boolean;
  reportType:any;
  isFetching:any;
  entryTypeId:any;
  reporttable:any ;
  isreportFetching:any;
  weightType:any ;
  onRefresh:any;
  setFilterTable: React.Dispatch<React.SetStateAction<any>>;
  // other props...
}

export const ReportViewItem = ({ data,isLoading, reportType, isFetching, entryTypeId,  reporttable,isreportFetching,weightType,onRefresh,setFilterTable }: ReportViewItem_) => {
  const report = data?.res || {};

    const navigate = useNavigate()
        const handleNigate = (item: any) => {      
          
            navigate(getRoute(ROUTES.LOG_ADMIN_DETAIL, item.entryId));
  
        }
        
  const DetailColumn = {
  title: "",
  key: "detail",
  dataIndex: "detail",
  render: () => (
    <ArrowRightOutlined style={{ cursor: "pointer", fontSize: 16 }} />
  ),
  onCell: (record: any) => ({
    style: { cursor: "pointer" },
    onClick: () => {
      const selection = window?.getSelection()?.toString();
      if (!selection?.length) {
        handleNigate(record);
      }
    },
  }),
};
  const kpis = [
    { label: "Total Sales ", value: report.totalSalesVehicleCount },
    { label: "Total Purchase ", value: report.totalPurchaseVehicleCount },
    { label: "Total Store ", value: report.totalStoreVehicleCount },
    { label: "Total Vehicle", value: report.totalVehicleCount },
  ];

  const Tat = [
    { label: "Min. TAT", value: report.totalMinTat },
    { label: "Max. TAT", value: report.totalMaxTat },
    { label: "Avg. TAT", value: report.totalAvgTat },
    
  ];
  const SalesTolranceWeight = [
    // { label: "Min. Sales Tol...", value: report.minimumSTD },
    // { label: "Max. Sales Tol...", value: report.maximumSTD },
    // { label: "Avg. Sales Tol...", value: report.avgSTD },
    { label: "Total Under Weight", value: report.totalUnderWeight },
    { label: "Total Over Weight", value: report.totalOverWeight },
    { label: "Number of Visits", value: report.numberOfVisits },
    { label: "Number of Records", value: report.numberOfRecords },

  ];
  const Tolerance = [
    // { label: "Min. WB Tol...", value: report.totalMinWBT },
    // { label: "Max. WB Tol...", value: report.totalMaxWBT },
    // { label: "Avg. WB Tol...", value: report.totalAvgWBT },
    { label: "Weight Bridge 1", value: report.totalWB_1_WWeight },
    { label: "Weight Bridge 2", value: report.totalWB_2_WWeight },
    { label: "Difference", value: report.totalWeightBridgeDifference },
    { label: "Number of Visits", value: report.numberOfVisits },
    { label: "Number of Records", value: report.numberOfRecords },
  ];
    const PurchaseReport = [    
    { label: "Max Purchase", value: report.maximumPurchaseData },
    { label: "Min Purchase", value: report.minimumPurchaseData },
    { label: "Avg Purchase", value: report.avgPurchaseData },
    { label: "Total Purchase", value: report.totalPurchaseData },
  ];

  let itemsToShow: any[] = [];
  if (reportType === 1) itemsToShow = Tat;
  else if (reportType === 2 && entryTypeId === 1) itemsToShow = SalesTolranceWeight;
  else if (reportType === 2) itemsToShow = Tolerance;
  else if (reportType === 3) itemsToShow = kpis;
 else if(reportType ===5) itemsToShow= PurchaseReport
  // Table columns

  const extraColumns = [
    
    { title: "Material Name", dataIndex: "materialName", key: "materialName" },
    { title: "Expected Weight", dataIndex: "expectedWeight", key: "expectedWeight" },
    { title: "Net Weight", dataIndex: "netWeight", key: "netWeight" },
    { title: "Weight Difference", dataIndex: "weightDiff", key: "weightDiff" },
    {
      title: "Weight Type", dataIndex: "weightType", key: "weightType", render: (text: string) => {
        if (!text) return "-";

        let color = "";
        if (text === "OverWeight") color = "green";
        else if (text === "UnderWeight") color = "red";
        else color = "gray";

        return (
          <Tag
            color="transparent"
            style={{
              border: `1px solid ${color}`,
              color,
              background: `${color}10`, // light background shade
              fontWeight: 600,
              borderRadius: "8px",
              padding: "4px",
              minWidth: "100px",
              textAlign: "center",
            }}
          >
            {text}
          </Tag>
        );
      },
    },
    { title: "Driver Name", dataIndex: "driverName", key: "driverName" },
    { title: "Vehicle Number", dataIndex: "vNumber", key: "vNumber" },
    { title: "Status", dataIndex: "status", key: "status" },
  ];

  const TatColumns = [      
    { title: "Driver Name", dataIndex: "driverName", key: "driverName" },
    { title: "Vehicle Number", dataIndex: "vNumber", key: "vNumber" },
     { title: "Entry Type", dataIndex: "entryType", key: "entryType" },
    {
      title: "Entry Date",
      dataIndex: "entryDateTime",
      key: "entryDateTime",
      render: (text: string) => (text ? dayjs(text).format("DD-MM-YYYY HH:mm:ss") : "-"),
    },
    {
      title: "Exit Date",
      dataIndex: "exitDateTime",
      key: "exitDateTime",
      render: (text: string) => (text ? dayjs(text).format("DD-MM-YYYY HH:mm:ss") : "-"),
    },
    { title: "TAT", dataIndex: "tat", key: "tat" },
  ]

  const columns = [
    ...(Number(reportType) === 2 && Number(entryTypeId) === 1 ? [DetailColumn ,...extraColumns] : []),
    ...(Number(reportType) === 1 ? [DetailColumn ,...TatColumns ]: []),
    ...(Number(reportType) === 3 ? [DetailColumn ,...VehicleColumns] : []),
    ...(Number(reportType) === 2 && Number(entryTypeId) === 4 ? [DetailColumn ,...TolranceWebColumns] : []),
    ...(Number(reportType) === 4 ? [DetailColumn ,...SalesColumns] : []),
    ...(Number(reportType) === 5 ? [DetailColumn ,...PurchaseReportSalesView] : []),
  ];

 

  const downloadCSV = () => {
    if (!reporttable?.items || !reporttable?.items.length) return;

    const csvHeaders = columns.map((col) => col.title).join(",");
    const csvRows = reporttable?.items.map((row: any) =>
      columns.map((col) => `"${row[col.dataIndex] ?? ""}"`).join(",")
    );
    const csvContent = [csvHeaders, ...csvRows].join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `report.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  
    const handlePageChange = (Page: number) => {
         
        setFilterTable((prev:any) => ({ ...prev, Page: Page }));
    };



  return (
    <div className="space-y-6 p-4">
      <span className="text-xl font-bold">{
        (reportType == 2 && entryTypeId == 4) ? "Weight Bridge Tolerance" : (reportType == 2 && entryTypeId == 1) ? "Sales Item Tolerance" :
          report?.reportType}</span>
      {/* KPI Cards */}
      <div className="grid grid-cols-5 gap-4 text-center">
        {itemsToShow.map((item, idx) => (
          <Card key={idx} className="shadow-md" loading={isFetching}>
            <p className="text-sm text-gray-500">{item.label}</p>
            <h2 className="text-xl font-bold">{item.value}</h2>
          </Card>
        ))}
      </div>
      {/* <CardDashBoardView itemsToShow={itemsToShow} isFetching={isFetching} report={report}/> */}

      {/* Chart Section */}
      {/* Chart Section */}
      {reportType === 1? (
        
        <TatReportView data={data} isLoading={isLoading} />
      ) : reportType === 2 && entryTypeId === 1 ? (
        <>
         {weightType==1?(
          <>
           <TolranceSalesViewItem data={data} isLoading={isLoading}/>
          
          </>
         )
         :weightType==2?(
          <>
          
          <TolranceSalesViewUnderWeightItem data={data} isLoading={isLoading}/>
          </>
         ):(
          <>
           <TolranceSalesViewItem data={data} isLoading={isLoading}/>
          <TolranceSalesViewUnderWeightItem data={data} isLoading={isLoading}/>
          </>

         )}
         
        </>
      ) : reportType === 2 ? (
        <TolranceViewItem data={data} isLoading={isLoading}/>
      ) : reportType === 3 ? (

        <VehicleReportView data={data} isLoading={isLoading}/>
      ) : reportType == 4 ? (
        <SalesReportView data={data} isLoading={isLoading}/>
      ) : reportType == 5 ? (
        <PurachaseReportView data={data} isLoading={isLoading}/>
      ) : (
        "No data found."
        // <TatReportView data={data} />
      )}
      {/* Table Section */}
      <Card className="shadow-md">

        {(reportType == 1 && HasPermission(SideBarMenus.TATREPORT, 'print') ) || (reportType == 2 && HasPermission(SideBarMenus.TOLERANCEREPORT, 'print'))
        || (reportType == 3 && HasPermission(SideBarMenus.VEHICLEREPORT, 'print')) || (reportType == 4 && HasPermission(SideBarMenus.SALES, 'print')) || 
        (reportType == 5 && HasPermission(SideBarMenus.PURCHASE, 'print'))
        ? (
        <div className="mb-2 flex justify-end padding " >
          <Button type="primary" onClick={downloadCSV}>
            Download CSV
          </Button>

           <Button
          type="link"                // 👈 makes it look like blue text
          onClick={onRefresh}
          loading={isreportFetching}
          className="p-0 mb-2 ml-2"
          //style={{ padding: 0, marginBottom: 16 }}
        >
          Refresh Data
        </Button>
        </div>
          ):null }

            {/* pagination={{
            current: tableParams.page,
            defaultPageSize: tableParams.size,
            total: itemsCount,
          }} */}
       
        {reportType == 5 ?
          <Table
            columns={columns as any}
            dataSource={reporttable?.items?.map((row: any, i: number) => ({ ...row, key: i }))}
            pagination={{
            current: reporttable?.page,
            defaultPageSize: 10,
            total: reporttable?.total,
             onChange: handlePageChange,
          }}
            bordered
            loading={isFetching}
          />
          :
          <Table
            columns={columns as any}
            dataSource={reporttable?.items?.map((row: any, i: number) => ({ ...row, key: i }))}           
             pagination={{
            current: reporttable?.page,
            defaultPageSize: 10,
            total: reporttable?.total,
             onChange: handlePageChange,
          }}
            bordered
            loading={isFetching}
          />
        }
      </Card>
    </div>
  );
};
